import { render, staticRenderFns } from "./updateProfile.vue?vue&type=template&id=0bf330f8&scoped=true"
import script from "./updateProfile.vue?vue&type=script&lang=js"
export * from "./updateProfile.vue?vue&type=script&lang=js"
import style0 from "./updateProfile.vue?vue&type=style&index=0&id=0bf330f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf330f8",
  null
  
)

export default component.exports